import Edit from '@assets/icons/edit.svg'
import { Icon } from './Icon'

export const EditIcon = Icon(Edit)
